export function getAllYears() {
  const currentYear = new Date().getFullYear();
  const startYear = 2000;

  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(`${year}`);
  }

  return years;
}
